import { render, staticRenderFns } from "./shrinkable-menu.vue?vue&type=template&id=176573f4&scoped=true"
import script from "./shrinkable-menu.vue?vue&type=script&lang=js"
export * from "./shrinkable-menu.vue?vue&type=script&lang=js"
import style0 from "./shrinkable-menu.vue?vue&type=style&index=0&id=176573f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176573f4",
  null
  
)

export default component.exports